import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import {
  AlertService, ConditionStoreService, ContactsStoreService,
  FileStoreService,
  IAlertType, JobsStoreService, NotificationStoreService,
  OrdersStoreService,
  StaffStoreService, TransportStoreService, WarehouseStoreService
} from "../../../_shared/services";
import {CurrencyPipe, DatePipe, formatCurrency, JsonPipe, NgForOf, NgIf} from "@angular/common";
import {
  ClrCheckboxModule,
  ClrDatagridModule, ClrDatagridSortOrder,
  ClrDropdownModule, ClrLoadingModule,
  ClrModalModule,
  ClrTabsModule,
  ClrTooltipModule
} from "@clr/angular";
import {
  Companies, Conditions,
  Files,
  JobsList,
  Notification,
  OrdersList,
  SingleOrder,
  StatusButtons, WebserviceResponse
} from "../../../_shared/interfaces";
import { WarehouseSelectable } from "../../../_shared/interfaces/warehouse";
import { OrderTransportComponent } from "../order-transport/order-transport.component";
import { OrderDetailsDocumentsComponent } from "./order-details-documents/order-details-documents.component";
import {
  OrderDetailsWarehouseShortComponent
} from "./order-details-warehouse-short/order-details-warehouse-short.component";
import {
  OrderDetailsWarehousePositionComponent
} from "./order-details-warehouse-position/order-details-warehouse-position.component";
import { OrderDetailsEditPositionComponent } from "./order-details-edit-position/order-details-edit-position.component";
import { CommentFeatureCardComponent } from "../../../core/comment/comment-feature-card/comment-feature-card.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ClarityIcons, pencilIcon, printerIcon, windowCloseIcon, minusCircleIcon, angleIcon } from "@cds/core/icon";
import { getTenantConfig, getTenantStorage } from '../../../_shared/utils/tenant-context';

import { saveAs } from 'file-saver';
import { environment as env } from "../../../../environments/environment";
import { filesBaseUrl } from "../../../_shared/utils/rest-url";

import JSZip from "jszip";
import PackageJson from "../../../../../package.json";
import moment from "moment";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    ClrDropdownModule,
    DatePipe,
    CurrencyPipe,
    NgForOf,
    ClrTabsModule,
    ClrDatagridModule,
    ClrCheckboxModule,
    ClrTooltipModule,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    OrderTransportComponent,
    OrderDetailsDocumentsComponent,
    OrderDetailsWarehouseShortComponent,
    OrderDetailsWarehousePositionComponent,
    OrderDetailsEditPositionComponent,
    ClrLoadingModule,
    CommentFeatureCardComponent,
    JsonPipe
  ],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.sass'
})
export class OrderDetailsComponent {
  orders: SingleOrder = new SingleOrder();
  positions: OrdersList[] = [];
  foundPositions: JobsList[] = [];
  notification60: Notification[] = [];
  componentsFiles: Files[] = [];
  selectedFiles: Files[] = [];
  ordersDelivery: Files[] = [];
  deliveryAddress: Companies[] = [];
  projectId: string = '';
  orderId: number = 0;
  jobId: number = 0;
  positionId: number = 0;
  partId: number = 0;
  loading1: boolean = true;
  loading2: boolean = true;
  loading3: boolean = true;
  loading4: boolean = true;
  selected: OrdersList[] = [];
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  showPdf: boolean = false;
  hidePdfButton: boolean = true;
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  offerCondition: any = "";
  deliveryCondition: any = "";
  paymentCondition: any = "";
  deliveryConditionHasOption: boolean = false;
  private readonly tenantConfig = getTenantConfig();
  orderTotal: number = 0;
  modalUrl: string = "";
  modalContent: string = "";
  descSort = ClrDatagridSortOrder.DESC;
  devMode: boolean;

  // Transport-Auswahl Modal (Serien-/Chargennummern)
  showTransportModal: boolean = false;
  transportSelectables: WarehouseSelectable[] = [];
  selectedWarehouseIds: Set<number> = new Set<number>();
  private pendingTransportProjectId: string = '';
  private pendingTransportOrderId: number = 0;

  public ppsVersion: string = PackageJson.version;

  private filesDirectory = filesBaseUrl();

  statusButtons: StatusButtons[] = [
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle', locked: false },
    { state: 'confirmed', display: 'Bestätigt', label: 'label-info', icon: 'check-circle', locked: true },
    { state: 'running', display: 'In Arbeit', label: 'label-warning', icon: 'exclamation-triangle', locked: true },
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle', locked: false },
    { state: 'shipped', display: 'Abgeschickt', label: 'label-info', icon: 'check-circle', locked: false },
    { state: 'invoiced', display: 'Berechnet', label: 'label-green', icon: 'exclamation-circle', locked: true },
    { state: 'done', display: 'Erledigt', label: 'label-success', icon: 'info-circle', locked: true }
  ];

  // Für Ausdruck
  basic: boolean = false;
  clrModalSize: string = '';

  documentDefinition = getTenantLetterAssets().a4Letter;
  labelDefinition = getTenantLetterAssets().jobLabel;

  constructor(
    private orderss: OrdersStoreService,
    private staffss: StaffStoreService,
    private jobss: JobsStoreService,
    private filess: FileStoreService,
    private condss: ConditionStoreService,
    private contss: ContactsStoreService,
    private notess: NotificationStoreService,
    private transs: TransportStoreService,
    private warehousess: WarehouseStoreService,
    private router: Router,
    private datePipe: DatePipe,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(windowCloseIcon, pencilIcon, printerIcon, minusCircleIcon, angleIcon);
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.orderId = parseInt(params.get('ordid') ?? '0', 10);
    this.loadOrder(this.projectId, this.orderId);
    this.loadOrdersPositions(this.projectId, this.orderId);
    this.getComponentFiles(this.projectId, this.orderId);
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  updatePositionMode(index: number, positionId: number, partId: number) {
    this.editPos = 2;
    this.positionId = positionId;
    this.partId = partId;
  }

  showModal(fileid: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileid}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.loading3 = true;
    this.getComponentFiles(this.projectId, this.orderId);
  }

  warnPassiv() {
    this.alertDispatcher.show({
      message: 'ACHTUNG! Passive Komponente(n)! ',
      clrAlertType: IAlertType.WARNING
    }, 15000);
    return
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(orderStatus: string, buttons: StatusButtons[]) {
    const idx = buttons.findIndex(el => el.state === orderStatus);
    return idx >= 0 ? idx : 0;
  };

  changeOrderStatus(projectId: string, orderId: number, status: number){
    if (confirm('Wollen Sie den Status dieser Bestellung wirklich auf "' + this.statusButtons[status].display + '" setzen?')) {
      this.orderss.updateOrderStatus(projectId, orderId.toString(), this.statusButtons[status].state)
        .subscribe({
          next: () => {
            this.loadOrder(projectId, orderId);
            this.loadOrdersPositions(projectId, orderId);
          },
          complete: () => {
            this.router.navigate(['/order/details/', projectId, orderId]).then(r => {});
          },
          error: () => {
            return
          }
        })
    }
  }

  /**
   * Der Bestellbogen nennt Liefertermin, Liefer- und Zahlungsbedingungen. Ohne
   * sie ist er keine vollstaendige Bestellung, deshalb bleibt der Knopf
   * gesperrt, bis alle drei stehen.
   *
   * Als Getter, nicht als Feld: die drei Werte aendern sich, wenn der Auftrag
   * neu geladen wird, und ein einmal auf false gesetztes Feld faende nie
   * zurueck. Genau das war der Fehler -- und `order_delivery` wurde gegen
   * '0000-00-00' geprueft, was das RMS gar nicht liefert: ein fehlendes Datum
   * kommt als Leerstring. Der Knopf war damit ohne Liefertermin frei.
   */
  get disablePdf(): boolean {
    return !(this.orders.cond_payment > 0)
        || !(this.orders.cond_delivery > 0)
        || !this.istDatum(this.orders.order_delivery);
  }

  /** Was dem Bestellbogen noch fehlt -- als Hinweis am gesperrten Knopf. */
  get pdfHinweis(): string {
    if (!this.disablePdf) {
      return '';
    }
    const fehlt = [
      this.istDatum(this.orders.order_delivery) ? '' : 'Liefertermin',
      this.orders.cond_delivery > 0 ? '' : 'Lieferbedingungen',
      this.orders.cond_payment > 0 ? '' : 'Zahlungsbedingungen',
    ].filter(Boolean);
    return 'Es fehlt noch: ' + fehlt.join(', ');
  }

  /** Ein Datum, das etwas bedeutet -- leer und die Null-Datumsformen nicht. */
  private istDatum(wert: string | null | undefined): boolean {
    const text = (wert ?? '').trim();
    return text !== '' && text !== '0000-00-00' && text !== '1970-01-01';
  }

  loadOrder(projectId: string, orderId: number) {
    this.orderss.getOrders(projectId, orderId, 0,'all').subscribe({
      next: data1 => {
        if (!data1 || !data1.object) {
          this.alertDispatcher.show({
            message: 'Keine Orderdaten gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.orders = data1.object[0];
      },
      complete: () => {
        // Mitarbeiter personalisieren
        this.staffStatus(this.orders.employee_phm);

        // dazugehörigen Job ermitteln
        this.jobId = this.orders.job_id;
        this.searchProjectPositions(this.projectId, this.jobId);
        this.loadList60(this.projectId, this.orderId, this.jobId);

        // Lieferscheine des Lieferanten laden
        this.getFilesSet([55], this.projectId);

        // Lieferadresse ermitteln
        this.getDeliveryAddress(this.orders.company_delivery);

        // Bedingungen ermitteln
        this.deliveryCondition = this.getCondition(this.orders.cond_delivery, 1);
        this.paymentCondition = this.getCondition(this.orders.cond_payment, 2);

        // Status gestalten
        const statusline = this.findButtonStatus(this.orders.order_status, this.statusButtons);
        this.statusLabel = this.statusButtons[statusline].label;
        this.statusText = this.statusButtons[statusline].display;

        // Check Klassifizierung
        this.checkClassification(this.orders.order_cid);

        // "PDF Anzeigen" - Button aktiv setzen, wenn Lieferbedingungen vorhanden
        if (this.orders.cond_delivery > 0) this.hidePdfButton = false;

        this.loading1 = false;
      },
      error: () => {
        return
      }
    });
  }

  async updateOrder(done: boolean) {
    this.editPos = 1;
    this.loadOrder(this.projectId, this.orderId);
    this.loadOrdersPositions(this.projectId, this.orderId);
    this.createOrder(this.positions)
  }

  loadOrdersPositions(projectId: string, orderId: number) {
    let factor: number = 0;
    this.orderTotal = 0;
    this.orderss.getOrdersPositions(projectId, orderId, 0, '0', '0').subscribe({
      next: data2 => {
        if (!data2 || !data2.object) {
          this.alertDispatcher.show({
            message: 'Keine Orderpositionen gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.positions = data2.object;

        this.positions.forEach((item) => {
          if (item.number_of_pieces == 0) { factor = 1 } else { factor = item.number_of_pieces }
          this.orderTotal += factor * item.budget;
        })

        this.updateTotal(projectId, orderId, this.orderTotal);
      },
      complete: () => {
        this.loading2 = false;
      },
      error: () => {
        return
      }
    });
  }

  deleteOrder(projectId: string, orderId: number) {
    if (confirm('Wollen Sie den Auftrag wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.orderss.deleteOrder(projectId, orderId)
        .subscribe({
          next: () => {},
          complete: () => {this.router.navigate(['/project/details/', this.splitProjectNumber(projectId, 0), this.splitProjectNumber(projectId, 1)]).then(r => {})
          },
          error: () => {
            return
          }
        })
    }
  }
  searchProjectPositions(projectID: string, jobID: number) {
    this.jobss.getJobsPositions(projectID, jobID,'0', '0', '').pipe(
      map(res => (res?.object ?? []).filter(p => p.active === true))
    ).subscribe({
      next: (activePositions) => {
        if (!activePositions || activePositions.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Positionen gefunden. ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.foundPositions = activePositions;
      },
      error: () => {
        return;
      }
    });
  }
  staffStatus(staffId: number){
    this.staffss.getStaffById(staffId)
      .subscribe({
        next: staff => {
          if (!staff) {
            return;
          }
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
          this.staffPhone = staff.object[0].phone;
        },
        complete: () => {
          if (this.devMode) console.log('StaffID ist ' + staffId);
        }
      })
  }

  private getComponentFiles(projectId: string, orderId: number) {
    this.filess.getComponentsFilesByOrder(projectId, orderId)
      .subscribe({
        next: data => {
          this.componentsFiles = data.object;
          this.descSort = ClrDatagridSortOrder.DESC;
        },
        complete: () => {
          this.loading3 = false;
        },
        error: () => {
          return
        }
      })
  }

  getCondition(condId: number, condType:number){
    if (condId == 0) {
      this.deliveryCondition = "---";
      this.paymentCondition = "---";
      this.offerCondition = "---";
    } else {
      this.condss.getConditionById(condId, condType)
        .subscribe({
            next: condition => {

              if (!condition?.object) return;
              if (!condition.object.length) return;

              switch (condType) {
                case 1:
                  this.deliveryCondition = `${condition.object[0].name} (${condition.object[0].text})`;
                  this.deliveryConditionHasOption = condition.object[0].option ?? false;
                  break;
                case 2:
                  this.paymentCondition = condition.object[0].name;
                  break;
                case 3:
                  this.offerCondition = condition.object[0].name;
                  break;
              }
            },
            error: () => {
              return
            }
          }
        )}
  }

  getDeliveryAddress(contactId: number){
    this.contss.getSingleCompany(contactId)
      .subscribe({
        next: address => {
          this.deliveryAddress = address.object;
        },
        complete: () => {},
        error: () => {
          return
        }
      })
  }

  checkClassification(contactId: number){
    let classification: string = '';
    this.contss.getSingleCompany(contactId)
      .subscribe({
        next: company => classification = company.object[0].classification ?? '',
        complete: () => {
          switch (classification){
            case "B":
              this.alertDispatcher.alertConfig.message = 'Firma ist nur nach vorheriger Überprüfung und Sonderfreigabe für Order zugelassen (Klassifizierung B)!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              break;
            case "C":
              this.alertDispatcher.alertConfig.message = 'Firma ist dauerhaft für Requests und Orders gesperrt (Klassifizierung C)!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
              break;
            case "":
              this.alertDispatcher.alertConfig.message = 'Firma hat KEINE Klassifizierung!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
              break;
            default:
              this.alertDispatcher.alertConfig.message = 'All engines running! ) ';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
              break;
          }
        },
        error: () => {
          return
        }
      })
  }

  loadList60(projectID: string, orderID: number, jobID: number) {
    this.notess.getNotification(projectID, 0, jobID, orderID,60).subscribe({
      next: (data: any) => {
        const response = data as WebserviceResponse<Notification[]>;
        if (!response || !response.object || response.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Notification gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.notification60 = response.object;
      },
      complete: () => {
        this.loading4 = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }

  updateTotal(prId: string, orderId: number, sum: number) {
    this.orderss.updateOrderTotal(prId, orderId, sum).subscribe({
      next: () => { },
      complete: () => {
        this.alertDispatcher.alertConfig.message = 'Gesamtsumme wurde aktualisiert.';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
        console.log("Summe ist: " + this.orderTotal);
      },
      error: () => {
        return
      }
    });
  }

  addRow(positionId: number, partId: number, technicalDrawing: string, positionName: string) {
    if (confirm('Wollen Sie die Position ' + positionId + '.' + partId + ' ' + positionName + ' (' + technicalDrawing + ') dem Auftrag wieder hinzufügen?')) {
      this.orderss.addSingleProjectPosition(this.projectId, this.orderId, positionId, partId)
        .subscribe({
          next: () => {
            this.loading2 = true;
          },
          complete: () => {
            this.loadOrdersPositions(this.projectId, this.orderId);
            this.loading2 = false;
          },
          error: () => {
            return
          }
        })
    }
  }

  async downloadZip(selectedFiles: Files[]) {
    if (!selectedFiles.length || !confirm(`Wollen Sie die ${selectedFiles.length} Datei(en) als ZIP herunterladen?`)) {
      return;
    }

    const zip = new JSZip();
    const phmToken = getTenantStorage('access_token');
    const url = `${this.filesDirectory}/download_file?token=${phmToken}`;

    for (const file of selectedFiles) {
      try {
        const response = await fetch(`${url}&file_id=${file.id}`);
        const blob = await response.blob();
        zip.file(file.fileName, blob);
      } catch (error) {
        this.alertDispatcher.alertConfig.message = `Fehler beim Laden von Datei: ${file.fileName}`;
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
      }
    }

    const zipBlob = await zip.generateAsync({ type: 'blob' });
    saveAs(zipBlob, `project-${this.projectId}-files.zip`);
    this.alertDispatcher.alertConfig.message = 'ZIP-Download abgeschlossen!';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
  }

  createOrder(positions : any[]) {
    let orderValue = 0.00;
    let formattedDeliveryDate = '';
    let formattedName = '';
    let formattedMaterial = '';

    let posTable = [[{ text: 'Pos.'}, { text: 'Bezeichnung'}, { text: 'Zeichnung', colSpan: 1, style: '' }, { text: 'Material'}, { text: 'Kennzeichnung'}, { text: ''},  { text: 'Anzahl'}, { text: 'Stückpreis in EUR', alignment: 'right' }]];

    positions.forEach(position => {
      formattedName = position.name;
      formattedMaterial = position.material;
      if (position.description) formattedName += '\n(' + position.description + ')';
      if (position.heat_nr) formattedMaterial += '\n' + position.heat_nr;
      if (position.taric && position.taric !== "0") formattedName += '\n(Zolltarifnummer: ' + position.taric + ')';
      if (position.delivery_date === '2020-01-01' || !position.delivery_date) { formattedDeliveryDate = '';
      } else {
        formattedDeliveryDate = this.datePipe.transform(position.delivery_date, 'dd.MM.yyyy') ?? '';
      }

      // Auftragssumme berechnen
        if (position.technology) {
          orderValue = orderValue + parseFloat(position.budget);
        } else {
          orderValue = orderValue + (position.number_of_pieces * parseFloat(position.budget));
        }

        switch (position.part) {
          case 0: {
            if (position.technology) {
              posTable.push(
                [position.position, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', {
                  text: formatCurrency(position.budget, 'de', '', 'EUR'),
                  alignment: 'right'
                }]
              );
            } else {
              posTable.push(
                [position.position, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, {
                  text: formatCurrency(position.budget, 'de', '', 'EUR'),
                  alignment: 'right'
                }]
              );
            }
            break;
          }
          default: {
            if (position.technology) {
              if (position.budget > 0) {
                posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', {
                    text: formatCurrency(position.budget, 'de', '', 'EUR'),
                    alignment: 'right'
                  }]
                );
              } else {
                posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', '']
                );
              }
            } else {
              if (position.budget > 0) {
                posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, {
                    text: formatCurrency(position.budget, 'de', '', 'EUR'),
                    alignment: 'right'
                  }]
                );
              } else {
                posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, '']
                );
              }
            }
            break;
          }
        }

        if (position.remarks) {
          posTable.push(
            [{text: ""}, {text: ""}, {text: ""}, {
              text: position.remarks,
              colSpan: 3,
              style: 'table'
            }, {text: ""}, {text: ""}, {text: ""}, {text: ""}]
          )
        }
    });

    this.documentDefinition.info.title = 'PPS Bestellung';
    this.documentDefinition.info.subject = 'BESTELLUNG ' + this.projectId + '.0002.' + this.orderId;
    this.documentDefinition.info.revison = this.ppsVersion;

    (this.documentDefinition.content[0] as any).columns[0].text = this.orders.company_name + '\n' + this.orders.order_street + '\n' + this.orders.order_postcode + ' ' + this.orders.order_city;
    if(this.orders.order_country && (this.orders.order_country != 'Deutschland')) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.orders.order_country
    }
    (this.documentDefinition.content[0] as any).columns[2].text = this.tenantConfig.letterCity + ', ' + moment(this.orders.order_date).format("DD.MM.yyyy") + '\n\nIhr Ansprechpartner:\n' + this.staffFirstName + ' ' + this.staffLastName + '\n' + this.staffEMail + '\n' + this.staffPhone;
    (this.documentDefinition.content[1] as any).text = 'BESTELLUNG ' + this.orders.project_id + '.0002.' + this.orders.order_id ;
    (this.documentDefinition.content[2] as any).text = 'zu Ihrem Angebot mit der Nummer ' + this.orders.purchasing_id + '. Unsere Bestellnummer im Schriftverkehr unbedingt angeben!';
    if(this.orders.employee_order === 0) {
      (this.documentDefinition.content[3] as any).text = 'Sehr geehrte Damen und Herren,\n\n' +
        'hiermit erhalten Sie nachstehenden Auftrag zur Lieferung, entsprechend unseren umseitigen AGB:';
    } else {
      (this.documentDefinition.content[3] as any).text = 'Sehr geehrte(r) ' + this.orders.order_salutation + ' ' + this.orders.order_lastname + ',\n\n' +
        'hiermit erhalten Sie nachstehenden Auftrag zur Lieferung, entsprechend unseren umseitigen AGB:';
    }

    (this.documentDefinition.content[4] as any).table.headerRows = 1;
    (this.documentDefinition.content[4] as any).table.widths = [ 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    (this.documentDefinition.content[4] as any).table.body = posTable;
    // (this.documentDefinition.content[5] as any).table.body = footTable;

    // Tenant-spezifische Postfächer; fehlen sie, entfällt der jeweilige Hinweis.
    let invoiceInstruction = 'Bestellnummer und Bestellposition sind in allen Schriftstücken unbedingt\n' + 'anzugeben,';
    if (this.tenantConfig.supplierInvoiceEmail) {
      invoiceInstruction += '\n' + 'Rechnungen ausschließlich elektronisch (Format: XRechnung, ZUGFeRD oder PDF) an folgende E-Mail Adresse: ' + this.tenantConfig.supplierInvoiceEmail;
    }

    this.documentDefinition.content[5] = {
      stack: [
        {
          text: 'Bei erkennbarem Terminverzug ist die ' + this.tenantConfig.legalCompanyName + ' unverzüglich zu unterrichten!', style: 'normal', margin: [30, 0]
        },
        {
          layout: 'noBorders',
          table: {
            headerRows: 0,
            widths: [ 'auto', 'auto' ],

            body: [
              [ 'Preis gesamt:', formatCurrency(orderValue, 'de', 'EUR', 'EUR') + ' netto, zzgl. gesetzlicher MWSt.' ],
              [ 'Lieferbedingungen:', ' mit transportfähiger und zweckmäßiger Verpackung' ],
              [ 'Liefertermin:', moment(this.orders.order_delivery).format("DD.MM.yyyy") ],
              [ 'Lieferung: ', this.deliveryCondition ],

              ...(this.deliveryConditionHasOption && this.deliveryAddress?.length > 0 ? [
                [ 'Lieferadresse: ', this.deliveryAddress[0].company + '\n' + this.deliveryAddress[0].street + '\n' + this.deliveryAddress[0].postcode + ' ' + this.deliveryAddress[0].city + '\n' + this.deliveryAddress[0].country ]
              ] : []),

              [ 'Rechnung:', invoiceInstruction ],
              [ 'Zahlungsbedingungen:', this.paymentCondition ],
              [ 'Haftung:', 'entsprechend BGB in der gültigen Fassung vom 01.02.2002' ],
              [ 'Gewährleistung:', 'bestellgerecht mit Zeugnissen' ]
              ]
          },
          style: 'normal',
          margin: [30, 10]
        },
      ]
    } as any;

    // Der Abschnitt "Dokumentation" ist tenant-spezifisch; ist für den Tenant
    // keiner hinterlegt, bleibt nur die Bitte um Auftragsbestätigung stehen.
    const documentation = this.tenantConfig.orderDocumentation;
    const documentationBlocks: any[] = [];

    if (documentation) {
      documentationBlocks.push(
        { text: 'Dokumentation:', style: 'fett', margin: [30, 10] },
        { text: 'Zusammen mit der Lieferung erhalten wir die vom Auftragnehmer kostenlos zu erstellende Prüfbescheinigung.' +
            (this.tenantConfig.certificateEmail ? ' Diese muss zeitgleich per Mail als PDF- Datei an ' + this.tenantConfig.certificateEmail + ' zugesendet werden.' : '') +
            ' ' + documentation.scopeNotice + '\n\n' +
            'Die Prüfbescheinigungen sind mit Angabe der Bestellnummer und Bestellposition zu versehen. \nBeispiele für zu erstellende Prüfbescheinigungen:\n' +
            documentation.certificateExamples.map(example => '- ' + example).join('\n'), style: 'normal', margin: [30, 0] }
      );

      if (documentation.closingNotice) {
        documentationBlocks.push(
          { text: '\n' + documentation.closingNotice + '\n\n', style: 'normal', margin: [30, 0] }
        );
      }
    }

    this.documentDefinition.content[6] = {
      stack: [
        { text: 'Wir erbitten umgehend Ihre Auftragsbestätigung!', style: 'fett', margin: [30, 10] },
        ...documentationBlocks,
      ]
    } as any;

    this.generatePdf();
  }

  createTransportNote(projectId: string, orderId: number) {
    this.warehousess.getWarehouseSelectable(projectId, orderId).subscribe({
      next: (res: WebserviceResponse<WarehouseSelectable[]>) => {
        const items = res?.object ?? [];

        // Wie beim Lieferschein: Auswahl anbieten, sobald Lagerbestand da ist.
        if (items.length > 0) {
          // Auswahl-Modal anzeigen
          this.transportSelectables = items;
          this.selectedWarehouseIds = new Set(items.map(i => i.warehouse_id));
          this.pendingTransportProjectId = projectId;
          this.pendingTransportOrderId = orderId;
          this.showTransportModal = true;
        } else {
          // Kein Bestand → direkt aus den Order-Positionen erstellen
          if (confirm('Wollen Sie einen Transportschein passend zu dieser Order (' + projectId + '.0002.' + orderId + ') zur weiteren Bearbeitung erstellen?')) {
            this.doCreateTransportNote(projectId, orderId, []);
          }
        }
      },
      error: () => {
        // Bei Fehler: Fallback auf direktes Erstellen
        if (confirm('Wollen Sie einen Transportschein passend zu dieser Order (' + projectId + '.0002.' + orderId + ') zur weiteren Bearbeitung erstellen?')) {
          this.doCreateTransportNote(projectId, orderId, []);
        }
      }
    });
  }

  toggleWarehouseSelection(id: number) {
    if (this.selectedWarehouseIds.has(id)) {
      this.selectedWarehouseIds.delete(id);
    } else {
      this.selectedWarehouseIds.add(id);
    }
  }

  selectAllWarehouses() {
    this.selectedWarehouseIds = new Set(this.transportSelectables.map(i => i.warehouse_id));
  }

  confirmTransportModal() {
    const ids = Array.from(this.selectedWarehouseIds);
    this.showTransportModal = false;
    this.doCreateTransportNote(this.pendingTransportProjectId, this.pendingTransportOrderId, ids);
  }

  private doCreateTransportNote(projectId: string, orderId: number, warehouseIds: number[]) {
    this.transs.createTransportNote(projectId, orderId, warehouseIds.length > 0 ? warehouseIds : undefined, this.orders.job_pk || undefined)
      .subscribe({
        next: (data: WebserviceResponse<boolean>) => {
          if (!data || data.hasErrors || !data.message) {
            this.alertDispatcher.show({
              message: ' Transportschein konnte nicht erstellt werden! ',
              clrAlertType: IAlertType.WARNING
            }, 2000);
            return;
          }
          const transportId: number = Number(data.message);
          if (isNaN(transportId)) {
            this.alertDispatcher.show({
              message: ' Ungültige ID! ',
              clrAlertType: IAlertType.WARNING
            }, 2000);
            return;
          }
          this.router.navigate(['/transport/details/', projectId, this.jobId, transportId, orderId]).then(r => {});
        },
        complete: () => { },
        error: () => { return; }
      });
  }

  createNotification(projectId: string, orderId: number, jobId: number) {
    if (confirm('Wollen Sie eine Mitteilung zu dieser Order (' + projectId + '.0002.' + orderId + ') zur weiteren Bearbeitung erstellen?')) {
      this.notess.createNotification(projectId, jobId, orderId,60)
        .subscribe({
          next: (data: WebserviceResponse<boolean>) => {
            if (!data || data.hasErrors || !data.message) {
              this.alertDispatcher.show({
                message: ' Mitteilung konnte nicht erstellt werden! ',
                clrAlertType: IAlertType.WARNING
              }, 2000);
              return;
            }
            // message enthält die ID (muss umgewandelt werden)
            const notificationId: number = Number(data.message);

            if (isNaN(notificationId)) {
              this.alertDispatcher.show({
                message: ' Ungültige ID! ',
                clrAlertType: IAlertType.WARNING
              }, 2000);
              return;
            }

            this.router.navigate(['/notification/details/', projectId, jobId, notificationId]).then(r => {});
          },
          complete: () => { },
          error: () => {
            return
          }
        });
    }
  }

  generatePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);

    documentGenerator.getDataUrl((dataUrl: string) => {
      const targetElement = document.querySelector('#documentContainer');
      targetElement!.innerHTML = '';

      if (!targetElement) {
        this.alertDispatcher.alertConfig.message = 'PDF-Container nicht gefunden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        return; // Exit the function if the element doesn't exist
      }

      const pdfIframe = document.createElement('iframe');
      pdfIframe.src = dataUrl;
      pdfIframe.width = '100%';
      pdfIframe.height = '100%';
      targetElement.appendChild(pdfIframe);
    })
  }

  archivePdf() {
    if (confirm('Wollen Sie die Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf archivieren?')) {
      this.safePdf();
    }

    this.alertDispatcher.show({
      message: ' Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf wurde archiviert.',
      clrAlertType: IAlertType.SUCCESS
    }, 5000);
  }

  async downloadPdf(){
    if (confirm('Wollen Sie die Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf wirklich herunterladen?')) {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf');
    }

    await this.safePdf();

    this.alertDispatcher.alertConfig.message = 'Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf wurde herunterladen.';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
  }

  async printPdf() {
    if (confirm('Wollen Sie die Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf ausdrucken?')) {
      pdfMake.createPdf(this.documentDefinition).print();
    }

    await this.safePdf()

    this.alertDispatcher.show({
      message: ' Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf wurde an den Drucker übergeben. ',
      clrAlertType: IAlertType.INFO
    }, 2000);
  }

  safePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
    documentGenerator.getBlob((blob: Blob) => {
      // Convert Blob to File
      const file = new File(
        [blob], // Blob content
        'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf',
        { type: blob.type, lastModified: Date.now() } // File metadata
      );

      // Now, send the file instead of the Blob
      this.filess.sendFile(file, 20, this.orders.order_id, this.orders.project_id, this.jobId, '', 'Bestellung ' + this.orders.project_id + '.0002.' + this.orders.order_id)
        .subscribe({
          next: (data) =>
          {
            if (this.devMode) console.log("done")
          },
          complete: () => {
            this.alertDispatcher.show({
              message: ' Datei ' + 'Order_' + this.orders.project_id + '.0002.' + this.orders.order_id + '.pdf wurde gespeichert.',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
          },
          error: (error) => console.error("Error:", error)
        });
    });
  }

  printLabel(position: OrdersList) {
    this.labelDefinition.content[0].table.body[0][1] = this.projectId + '.0006.' + this.jobId;
    this.labelDefinition.content[0].table.body[1][0] = { text: 'Order Nr:', style: 'fett' };
    this.labelDefinition.content[0].table.body[1][1] = this.projectId + '.0002.' + this.orderId;
    this.labelDefinition.content[0].table.body[2][1] = position.name;
    this.labelDefinition.content[0].table.body[3][1] = position.number_of_pieces.toString();
    this.labelDefinition.content[0].table.body[4][1] = position.technical_drawing;
    this.labelDefinition.content[0].table.body[5][1] = position.material;
    this.labelDefinition.content[0].table.body[6][1] = position.heat_nr;
    if (confirm('Wollen Sie ein Label zur Position ' + position.position + '.' + position.part + ' ausdrucken?')) {
      pdfMake.createPdf(this.labelDefinition).print();
    }

    this.alertDispatcher.alertConfig.message = 'Das Label wurde an den Drucker übergeben.';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
  }

  // Lieferscheine des Lieferanten laden
  private getFilesSet(doctype: number[], projectId: string) {
    this.filess.getFilesSet(doctype, projectId, this.jobId, this.orderId).subscribe({
      next: data => {
        this.ordersDelivery = data.object;
      },
      complete: () => {

      },
      error: () => {
        return
      }
    })
  }

  loadFile(fileID: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.filess.downloadFile(fileID)
        .subscribe(
          {
            next: data => {
              saveAs(data, fileName);
            },
            complete: () => {
              this.alertDispatcher.show({
                message: ' Die Datei ' + fileName + ' wurde erfolgreich heruntergeladen! ',
                clrAlertType: IAlertType.INFO
              }, 5000);
            },
            error: () => {
              this.alertDispatcher.show({
                message: ' Der Download ist fehlgeschlagen! ',
                clrAlertType: IAlertType.WARNING
              }, 5000);
            }
          });
    }
  }

  onDelete() {
    let choosenPositions = this.selected;
    if (confirm('Wollen Sie die ausgewählten Positionen tatsächlich löschen?')) {
      choosenPositions.forEach(array => {
        if (this.devMode) console.log("ich lösche " + array.position + '.' + array.part);
        this.deletePosition(this.projectId, this.orderId, array.position, array.part ?? 0)
      });

      this.loadOrder(this.projectId, this.orderId);
      this.loadOrdersPositions(this.projectId, this.orderId);

      this.alertDispatcher.alertConfig.message = 'Die Positionen wurden gelöscht.';
      this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
    }
  }

  deletePosition(projectId: string, orderId: number, positionId: number, partId: number) {
    this.orderss.deleteOrdersPosition(projectId, orderId, positionId, partId)
      .subscribe({
        next: () => {},
        complete: () => {
          this.alertDispatcher.alertConfig.message = 'Position ' + projectId + '.' + partId + ' wurde gelöscht.'
          this.loadOrdersPositions(this.projectId, this.orderId);
        },
        error: () => {
          return
        }
      });
  }

  onWarehouseUpdated() {
    this.loadOrdersPositions(this.projectId, this.orderId);
  }

}
